// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Categories from '../components/Categories';
import Footer from "../components/Footer";

function Home() {
    return (
        <>
            <Hero />
            <Stats />
            <Categories />
            
        </>
    );
}

export default Home;
